import { IAvatarAssetColorsMapVariableWithTestColors } from './IAvatarAssetColorsMapVariableWithTestColors';

export interface IAvatarAssetColorsMapVariableWithTestColorsByAsset {
    assetId: string;
    colorMap: IAvatarAssetColorsMapVariableWithTestColors;
}
